import {
  STORAGE_KEY_B2C_SOURCE_URL,
  STORAGE_KEY_B2C_PRIMARY_SOURCE,
  STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE,
  STORAGE_KEY_B2C_COACHING_VISIBLE,
} from './constants';

export type SourceContext = {
  sourceUrl: string;
  primarySource: string;
  fifthStepVisible: boolean;
  coachingVisible: boolean; // CFM-1514
};

export const persistSourceContext = (ctx: Partial<SourceContext>): void => {
  if (typeof window === 'undefined') return;
  try {
    if (ctx.sourceUrl) localStorage.setItem(STORAGE_KEY_B2C_SOURCE_URL, ctx.sourceUrl);
    if (ctx.primarySource) localStorage.setItem(STORAGE_KEY_B2C_PRIMARY_SOURCE, ctx.primarySource);
    if (ctx.fifthStepVisible !== undefined) {
      localStorage.setItem(STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE, ctx.fifthStepVisible ? '1' : '0');
    }
    if (ctx.coachingVisible !== undefined) { // CFM-1514
      localStorage.setItem(STORAGE_KEY_B2C_COACHING_VISIBLE, ctx.coachingVisible ? '1' : '0');
    }
  } catch (err) {
    console.warn('[sourceTracking] Failed to write to localStorage:', (err as Error)?.message || err);
  }
};

export const readSourceContext = (): SourceContext => {
  if (typeof window === 'undefined') return { sourceUrl: '', primarySource: '', fifthStepVisible: true, coachingVisible: true };
  try {
    return {
      sourceUrl: localStorage.getItem(STORAGE_KEY_B2C_SOURCE_URL) || '',
      primarySource: localStorage.getItem(STORAGE_KEY_B2C_PRIMARY_SOURCE) || '',
      fifthStepVisible: localStorage.getItem(STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE) !== '0',
      coachingVisible: localStorage.getItem(STORAGE_KEY_B2C_COACHING_VISIBLE) !== '0', // CFM-1514
    };
  } catch (err) {
    console.warn('[sourceTracking] Failed to read from localStorage:', (err as Error)?.message || err);
    return { sourceUrl: '', primarySource: '', fifthStepVisible: true, coachingVisible: true };
  }
};

export const clearSourceContext = (): void => {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(STORAGE_KEY_B2C_SOURCE_URL);
    localStorage.removeItem(STORAGE_KEY_B2C_PRIMARY_SOURCE);
    localStorage.removeItem(STORAGE_KEY_B2C_FIFTH_STEP_VISIBLE);
    localStorage.removeItem(STORAGE_KEY_B2C_COACHING_VISIBLE); // CFM-1514
  } catch (err) {
    console.warn('[sourceTracking] Failed to clear localStorage:', (err as Error)?.message || err);
  }
};
